'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const compressor = new Tone.Compressor(-30, 3).toMaster()

var compressor = new _tone2.default.Compressor(-30, 3).toMaster();
var gain = new _tone2.default.Gain(1).connect(compressor);

exports.default = gain;


//////////////////
// WEBPACK FOOTER
// ./client/lib/output.js
// module id = 57
// module chunks = 0